module.exports = __webpack_public_path__ + "bed-quilt3-slogan.d7536ff2.png";